'use client'

import { Box, Text, Flex, Grid, Image, Button, Icon } from '@chakra-ui/react'
import { BottomNav } from '@/components/ui/bottom-nav'
import { FaArrowRightLong } from 'react-icons/fa6'
import NextLink from 'next/link'
export default function NoSubscriptions() {
  return (
    <Flex justify={'flex-end'} mx={-4} minH={['80vh', '80vh', '90vh']}>
      <Box
        backgroundImage={[
          'url("/subscriptions/nosub-mobile.svg")',
          'url("/subscriptions/nosub-mobile.svg")',
          'url("/subscriptions/nosub-desktop.svg")',
        ]}
        backgroundPosition={'center'}
        backgroundRepeat={'no-repeat'}
        backgroundSize={'cover'}
        w="100%"
        zIndex={2}
        pb={[20, 10]}
        display="flex"
        flexDir="column"
      >
        <Box
          pb={10}
          px={[4, 4, 4]}
          display="flex"
          alignItems="center"
          justifyContent="center"
          flex="1"
          w="100%"
          gap={6}
        >
          {/* <Image
            src="/no-subs-man.png"
            h={['28vh', '28vh', '60vh']}
            w="auto"
            alt="No Subscriptions"
          /> */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flex="1"
            flexDir={'column'}
            maxW="350px"
            w={['80%', '80%', '100%']}
            mt={-20}
          >
            <Image
              src="/subscriptions/nosubicon.svg"
              boxSize={100}
              alt="No Subscriptions"
              mb={5}
            />
            <Text
              textAlign={'center'}
              fontSize={['xl', 'xl', '2xl']}
              fontWeight="bold"
            >
              Uh Oh! Looks like you aren&apos;t subscribed to any channels.
            </Text>
            <Text textAlign={'center'} mt={2}>
              More you watch, more you add watch time earnings to your wallet!
            </Text>

            <Button
              bg="lyk-green"
              color="white"
              _hover={{ bg: 'lyk-green' }}
              rightIcon={<Icon as={FaArrowRightLong} />}
              size="sm"
              px={8}
              py={6}
              mt={8}
              as={NextLink}
              href="/home"
            >
              Find some here
            </Button>
          </Box>
        </Box>
      </Box>
      <BottomNav />
    </Flex>
  )
}
